<template>
  <div>
    <p>{{title}}</p>  
          <div class="v-responsive">
              <CustomButton class="button button1" style=" padding-left: 20px; padding-right:20px" v-for="(item, index) in buttons" :content="item" :key="index" />
          </div>         
  </div>
</template>
<script>

import CustomButton from "./CustomButton";
export default {
  props: ["message"],
  components: { CustomButton },
  data() {
    return {
      buttons: [],
      title: ""
    };
  },
  created() {
    this.buttons = this.message.message.message.attachment.payload.buttons;
    this.title = this.message.message.message.attachment.payload.text;
  }
};
</script>
<style lang="scss" scoped>
  .v-responsive {
    position: relative;
    overflow: hidden;
      -webkit-box-flex: 1;
      -ms-flex: 1 0 auto;
    flex: 1 0 auto;
    max-width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
  .button {
    
    border: none;
    color: white;
    padding: 1px 100%;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 2px 2px;
    -webkit-transition-duration: 0.4s; 
    transition-duration: 0.4s;
    cursor: pointer;
    border-radius: 20px;
  }

  .button1 {
    background-color: white; 
    color: black; 
    border: 1px solid rgba(0, 0, 0, .20);
}

  .button1:hover {
    color: white;
  }

</style>